<mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<div class="table-responsive">
    <table *ngIf="!isLoading" [hidden]="!dataSource || dataSource.length == 0" mat-table [dataSource]="dataSource"
        class="table-striped">
        <ng-container matColumnDef="nrtRelacionada">
            <th mat-header-cell *matHeaderCellDef> NRT </th>
            <td mat-cell *matCellDef="let element"> <a class="showLink" (click)="refresh()" [routerLink]="['/relatorios/tracking/consulta-pedido-detalhes-interna']" [queryParams]="{ pedidoId: element.nrtRelacionada}">{{element.nrtRelacionada}}</a> </td>
        </ng-container>
        <ng-container matColumnDef="tipoPedido">
            <th mat-header-cell *matHeaderCellDef> Tipo pedido </th>
            <td mat-cell *matCellDef="let element"> {{element.tipoPedido }} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
<div *ngIf="!dataSource || dataSource?.length == 0" style="min-height: 100px"
    class="d-flex justify-content-center align-items-center">
    <strong>Não há informação a ser exibida!</strong>
</div>
